import Vue from "vue";

export const showcaseEventBus = new Vue({
    data() {
        return {
            showcasedCard: null,
        };
    },
    methods: {
        setShowcasedCard(card) {
            this.showcasedCard = card;
        }
    }
});